// Configuration for API endpoints
// This allows us to change API URLs based on environment (dev/prod)

// Get the API URL from environment variables
const envApiUrl = process.env.REACT_APP_API_URL;
const isDemoMode = process.env.REACT_APP_DEMO_MODE === 'true';

// Determine the API base URL based on environment
let API_BASE_URL = '';

if (isDemoMode) {
  // Demo mode - will use mock data
  API_BASE_URL = '';
  console.log('🎯 Running in DEMO MODE with mock data');
} else if (envApiUrl) {
  // Development environment with explicit API URL
  if (envApiUrl.startsWith('http://') || envApiUrl.startsWith('https://')) {
    API_BASE_URL = envApiUrl;
  } else {
    API_BASE_URL = `http://${envApiUrl}`;
  }
} else {
  // Production/Docker environment - use relative URLs
  // This means requests will go to the same origin (same host and port)
  API_BASE_URL = '';
}

// Debug logging for configuration
console.log('Environment REACT_APP_API_URL:', envApiUrl || '[not set]');
console.log('Environment REACT_APP_DEMO_MODE:', isDemoMode ? 'true' : 'false');
console.log('Resolved API_BASE_URL:', API_BASE_URL || '[demo/relative URLs]');

export { API_BASE_URL, isDemoMode };
